import React from 'react';
import { DataGrid, GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';
import {
  StudentPaymentSchemeWithMetrics,
  FeeFineDetailsData
} from '../../../types/paymentScheme';
import { getFeeFineDetailsColumns } from '../utils/feeFineDetailsTableColumns';
import { dataGridSx } from '../../common/styled/DataGrid';
import pallet from '../../../layouts/pallet';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import tableColumnUtils from '../../../utils/tableColumnUtils';

interface FeeFineDetailsTableProps {
  title: string;
  feeDetails: FeeFineDetailsData[];
  isLoading: boolean;
  checkboxSelection?: boolean;
  rowSelectionModel?: GridRowSelectionModel;
  onRowSelectionModelChange?: (selectionModel: GridRowSelectionModel) => void;
  onApproveRejectClick: (scheme: StudentPaymentSchemeWithMetrics) => void;
}

const FeeFineDetailsTable: React.FC<FeeFineDetailsTableProps> = ({
  title,
  feeDetails,
  isLoading,
  checkboxSelection = false,
  rowSelectionModel,
  onRowSelectionModelChange,
  onApproveRejectClick
}) => {
  const { paymentUser } = useSelector((state: RootState) => state.paymentUser);

  const columns: GridColDef[] = getFeeFineDetailsColumns(
    feeDetails,
    onApproveRejectClick,
    paymentUser
  );

  return (
    <Box mb='24px'>
      <Typography fontSize='18px !important' fontWeight={700} mb='16px'>
        {title}
      </Typography>
      <Box sx={{ width: '100%' }}>
        <DataGrid
          rows={feeDetails}
          columns={columns}
          loading={isLoading}
          checkboxSelection={checkboxSelection}
          rowSelectionModel={rowSelectionModel}
          onRowSelectionModelChange={onRowSelectionModelChange}
          getRowId={(row) => row._id}
          disableColumnMenu
          pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
          initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
          sx={{
            ...dataGridSx(pallet),

            '& .MuiDataGrid-virtualScroller': {
              overflowY: 'auto'
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default FeeFineDetailsTable;
